import { Timestamp } from '@angular/fire/firestore';

export interface Lesson {
  id?: string;
  lessonName?: string;

  gradeId?: string;
  avgAge?: number;

  tags?: string[];

  notesType?: NotesType;
  notesImported?: boolean;
  notesUrl?: string;

  groupId?: string;

  lessonStatus?: LessonStatus;

  createdBy?: string;
  createdById?: string;
  memberPhotoUrl?: string;

  created?: Timestamp;
  modified?: Timestamp;
}

export enum LessonStatus {
  available = 'available',
  unavailable = 'unavailable',
}

export enum NotesType {
  pdf = 'pdf',
  video = 'video',
  text = 'text',
  other = 'other',
}
